import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';

/**
 * Generated class for the WelcomemsgPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-welcomemsg',
  templateUrl: 'welcomemsg.html',
})
export class WelcomemsgPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WelcomemsgPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcomemsg/welcomemsg.ts